<template>
  <div class="main-wrapper">
    <div class="inner">
      <article class="content">
        <button
          v-if="
            i18n.global.locale.value === 'uz' ||
              i18n.global.locale.value === 'uz-to'
          "
          @click="
            switchLanguage(i18n.global.locale.value === 'uz' ? 'uz-to' : 'uz')
          "
          class="change-latin"
          title="Lotin va Kirillga o'zgartirish"
        >
          {{
            $t(
              `main.short_lang.${
                i18n.global.locale.value === "uz" ? "uz-to" : "uz"
              }`
            )
          }}
        </button>
        <div class="gallery-holder">
          <div
            class="main-gallery-holder"
            :style="{
              height: show.fullBg ? '100vh' : '',
              position: show.fullBg ? 'fixed' : 'relative'
            }"
          >
            <FadeCarousel :images="[active]" />
          </div>
          <div class="linear-gradient top"></div>
          <div class="linear-gradient bottom"></div>
          <div class="back-button" v-if="hasBack()" @click="$router.back()">
            <i class="fas fa-chevron-left back-icon"></i>
            <div class="back-text">{{ $t("main.return") }}</div>
          </div>
          <router-link
            :to="
              $i18nRoute({
                name: 'FeedWrapper'
              })
            "
            class="back-button"
            title="Go back"
            v-else
          >
            <i class="fas fa-chevron-left back-icon"></i>
            <div class="back-text">{{ $t("main.main") }}</div>
          </router-link>
          <button
            v-if="
              i18n.global.locale.value === 'uz' ||
                i18n.global.locale.value === 'uz-to'
            "
            @click="
              switchLanguage(i18n.global.locale.value === 'uz' ? 'uz-to' : 'uz')
            "
            class="change-latin-mobile"
            title="Lotin va Kirillga o'zgartirish"
          >
            {{
              $t(
                `main.short_lang.${
                  i18n.global.locale.value === "uz" ? "uz-to" : "uz"
                }`
              )
            }}
          </button>
        </div>
        <div class="animation_scroll" ref="anim_scroll"></div>
        <div class="else-content">
          <div class="meta-holder">
            <div class="meta-mob-bg"></div>
            <transition name="fromtop" appear>
              <div class="search-cont">
                <i @click="handleSearch" class="fas fa-search"></i>
                <form @submit.prevent="handleSearch">
                  <input
                    :placeholder="$t('error.input')"
                    type="text"
                    v-model="query"
                    class="search-bar"
                  />
                </form>
              </div>
            </transition>
            <div
              class="cat-date"
              :class="{ 'shimmer-title': active?.id === -1 }"
            >
              <div class="category" :class="{ kground: active?.id === -1 }">
                {{ active?.sub_category?.name }}
              </div>
              <div class="slash">|</div>
              <div class="date" :class="{ kground: active?.id === -1 }">
                {{ handleDate(active?.pub_date, "dd mmmm") }}
                {{ handleTime(active?.pub_date) }}
              </div>
              <div class="views-mobile">
                <i class="fas fa-eye"></i> {{ active?.view_count }}
              </div>
            </div>
            <transition name="fromleft" appear>
              <div
                class="title"
                :class="{
                  small: smallTitleIndicator,
                  'shimmer-title': active?.id === -1
                }"
                ref="mainTitle"
              >
                <div class="info">
                  <span class="category">{{ active.sub_category?.name }}</span>
                  <div class="slash">|</div>
                  <div class="data-news">
                    <span class="day"
                      >{{ handleDate(active?.pub_date) }},
                    </span>
                    <span class="time">{{ handleTime(active?.pub_date) }}</span>
                  </div>
                  <span class="views-mobile"
                    ><i class="fas fa-eye"></i> {{ active?.view_count }}</span
                  >
                </div>
                <h1 :class="{ kground: active?.id === -1 }">
                  {{ active?.title }}
                </h1>
              </div>
            </transition>
          </div>
          <div class="collar-holder">
            <div class="spacer" ref="spacer"></div>
            <transition appear name="frombottom">
              <div class="collar" ref="collar">
                <button
                  v-if="
                    i18n.global.locale.value === 'uz' ||
                      i18n.global.locale.value === 'uz-to'
                  "
                  @click="
                    switchLanguage(
                      i18n.global.locale.value === 'uz' ? 'uz-to' : 'uz'
                    )
                  "
                  class="change-latin-tablet"
                  title="Lotin va Kirillga o'zgartirish"
                >
                  {{
                    $t(
                      `main.short_lang.${
                        i18n.global.locale.value === "uz" ? "uz-to" : "uz"
                      }`
                    )
                  }}
                </button>
                <div
                  class="collar-inner"
                  :class="{ 'animated-first-letter': active?.id === -1 }"
                >
                  <!-- <span class="headliner">Zamon</span> -->
                  <span class="brief-first-leter">{{ active?.brief }}</span>
                  <br />
                  <span
                    class="content"
                    ref="description"
                    :class="{ 'kground ': active?.id === -1 }"
                    v-html="active?.description"
                  >
                  </span>
                </div>
                <div class="video-content" v-if="active.video">
                  <VideoPlayer class="video" :url="active.video" />
                </div>
                <div class="tag-block">
                  <div class="tag" v-if="active.tags">
                    <div class="tag__title">
                      {{ $t("news__detail.tags_title") }}
                    </div>
                    <div
                      class="tag__link"
                      v-for="(tag, index) in tags"
                      :key="index"
                    >
                      <span v-if="typeof tag == 'string'">{{ tag }}</span>
                      <span v-else>{{ tag.name }}</span>
                    </div>
                  </div>
                  <div class="social-links">
                    <div class="social-links__title">
                      {{ $t("news__detail.share_title") }}
                    </div>
                    <div class="social">
                      <button class="link" href="#" @click="copyToClipBoard">
                        <i class="fas fa-link"></i>
                        <span>{{ $t("news__detail.share") }}</span>
                      </button>
                      <a
                        class="link"
                        target="_blank"
                        :href="
                          `https://www.facebook.com/sharer.php?u=${thisUrl}&text=${active?.title}\n\n${active?.brief}`
                        "
                        ><i class="fab fa-facebook-f"></i>
                        <span>{{ $t("news__detail.share_facebook") }}</span>
                      </a>
                      <a
                        class="link"
                        target="_blank"
                        :href="
                          `https://telegram.me/share/url?url=${thisUrl}&text=${active?.title}\n\n${active?.brief}`
                        "
                        ><i class="fab fa-telegram-plane"></i>
                        <span>{{ $t("news__detail.share_telegram") }}</span>
                      </a>
                      <a
                        class="link"
                        target="_blank"
                        :href="
                          `https://www.instagram.com/?url=${thisUrl}&text=${active?.title}\n\n${active?.brief}`
                        "
                        ><i class="fab fa-instagram"></i>
                        <span>{{ $t("news__detail.share_instagram") }}</span>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="recs-holder">
                  <div class="controls-wrap">
                    <div class="headliner">{{ $t("main.read_also") }}</div>
                    <div class="controls-holder">
                      <template v-if="isMobile">
                        <button
                          v-if="hasBack()"
                          @click="$router.go(-1)"
                          class="left"
                          title="Go back"
                        >
                          <i class="fad fa-chevron-left"></i>
                        </button>
                        <router-link
                          v-else
                          :to="
                            $i18nRoute({
                              name: 'FeedWrapper'
                            })
                          "
                          @click="$router.go(-1)"
                          class="left"
                          title="Go back"
                        >
                          <i class="fad fa-chevron-left"></i>
                        </router-link>
                      </template>
                      <button
                        v-else
                        @click="handleCarousel(-1)"
                        class="left"
                        :class="carouselIndicators.left ? '' : 'disabled'"
                        title="Spin Left"
                      >
                        <i class="fad fa-chevron-left"></i>
                      </button>
                      <button
                        @click="handleCarousel(1)"
                        class="right"
                        :class="carouselIndicators.right ? '' : 'disabled'"
                        title="Spin Right"
                      >
                        <i class="fad fa-chevron-right"></i>
                      </button>
                    </div>
                  </div>
                  <div class="carousel-holder">
                    <div class="carousel" ref="carousel">
                      <router-link
                        :to="
                          $i18nRoute({
                            name: 'NewsDetail',
                            params: { slug: item.url }
                          })
                        "
                        class="news-item"
                        :class="{ 'pointer-none': active?.id === -1 }"
                        v-for="item in active?.recommendation"
                        :key="item.id"
                      >
                        <div class="img-holder">
                          <ImageContainer
                            :class="{
                              kground: active?.id === -1,
                              'animated-img': active?.id === -1
                            }"
                            :src="item.image.medium"
                            :thumb="item.image.thumbnail"
                            :alt="item.title"
                            class="img"
                          />
                        </div>
                        <div class="cat-wrapper">
                          <div
                            class="cat-meta"
                            :class="{ kground: active?.id === -1 }"
                          >
                            {{ item.sub_category.name }}
                          </div>
                        </div>
                        <span class="title limited-text" style="--snup: 4">
                          <span
                            :class="{
                              kground: active?.id === -1
                            }"
                            style="word-break: break-word"
                            >{{ item.title }}</span
                          >
                        </span>
                        <div class="date-wrapper">
                          <span
                            class="date"
                            :class="{
                              kground: active?.id === -1
                            }"
                            >{{ handleDate(item.pub_date) }},</span
                          >
                          <span
                            class="date"
                            :class="{
                              kground: active?.id === -1
                            }"
                            style="padding-left: 0.44em"
                            >{{ handleTime(item.pub_date) }}</span
                          >
                        </div>
                      </router-link>
                    </div>
                    <div class="carousel-gradient"></div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="linear-gradient bottom spec"></div>
      </article>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer";
import FadeCarousel from "@/components/FadeCarousel";
import {
  ref,
  reactive,
  onMounted,
  onBeforeUnmount,
  computed,
  watch
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useNavigation } from "@/utils/navigation";
import { useOrm } from "@/utils/orm";
import { useFormatter } from "@/utils/formatter";
import { useRouter } from "vue-router";
import ImageContainer from "@/components/ImageContainer";
import { useLanguage } from "@/utils/language";
import { KEYWORDS } from "@/utils/constants";

export default {
  components: {
    FadeCarousel,
    ImageContainer,
    VideoPlayer
  },
  setup() {
    const query = ref("");
    const router = useRouter();
    const route = useRoute();
    const isServer = computed(() => typeof window === "undefined");

    const slug = route.params.slug;
    const store = useStore();

    const carousel = ref(null);
    const carouselIndicators = reactive({
      left: false,
      right: true
    });
    const spacer = ref(null);
    const mainTitle = ref(null);
    const smallTitleIndicator = ref(false);
    const anim_scroll = ref(null);
    const collar = ref(null);
    const description = ref(null);
    const show = reactive({
      fullBg: false
    });
    const thisUrl = ref("");

    watch(
      isServer,
      () => {
        if (!isServer.value) {
          thisUrl.value = window.location.href;
        }
      },
      { immediate: true }
    );

    const { getByUniqueNews } = useOrm();

    const { i18n, switchLanguage } = useLanguage();

    const copyToClipBoard = () => {
      if (typeof window !== 'undefined') {
        const el = document.createElement("textarea");
        el.value = thisUrl.value;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
    };

    const handleError = () => {
      if (typeof window !== "undefined") router.push({ name: "404" });
    };

    const retrieveArticle = async slug => {
      if (slug !== undefined) {
        store.commit("removeActiveArtivle");
        if (typeof window !== "undefined") {
          store.commit(
            "setActiveArticle",
            getByUniqueNews(slug, store.getters.latestNews, "url") ?? {}
          );
        }

        await store.dispatch("getNewsDetails", { slug, err: handleError });

        if (typeof window !== "undefined") {
          setTimeout(() => {
            if (window.innerWidth <= 992) {
              anim_scroll.value.style.top = "100%";
            } else {
              if (window.innerWidth > 1576) {
                handleTextChange();
              }
            }
          }, 100);
        }
      }
    };

    const handleTextChange = () => {
      if (typeof window !== "undefined") {
        if (smallTitleTimeout) clearTimeout(smallTitleTimeout);
        let smallTitleTimeout = setTimeout(() => {
          smallTitleIndicator.value =
            (spacer.value.offsetHeight - window.scrollY) / 1.6 <=
            mainTitle.value.offsetHeight + mainTitle.value.offsetTop;
        }, 500);
      }
    };
    const isMobile = ref(false);

    const handleSearch = () => {
      router.push({
        name: `${i18n.global.locale.value || i18n.global.locale}_SearchQuery`,
        params: { query: query.value, category: "feed" }
      });
    };

    const handleMobileScroll = () => {
      if (typeof window !== "undefined") {
        anim_scroll.value.style.top =
          collar.value.getBoundingClientRect().top -
          window.pageYOffset +
          50 +
          "px";
        console.log(show.fullBg);
        console.log(anim_scroll.value.style.top);
      }
      show.fullBg = collar.value.getBoundingClientRect().top - 80 < 0;
    };

    // const changeImgSrc = async () => {
    //   await nextTick();
    //   if (typeof window !== "undefined") {
    //     description.value.getElementsByTagName("img").forEach((element) => {
    //       if (new URL(element.src).hostname === window.location.hostname)
    //         element.src = new URL(new URL(element.src).pathname, BASE_URL);
    //     });
    //   }
    // };

    // const changeIFrameAspect = async () => {
    //   await nextTick();
    //   description.value.getElementsByTagName("iframe").forEach((element) => {
    //     element.parentNode.style.position = "relative";
    //     element.parentNode.style.paddingTop = "56.25%"; // 16:9 Aspect Ratio
    //   });
    // };

    const setMetaTags = activeArticle => {
      if (
        typeof window !== "undefined" &&
        Object.keys(activeArticle).length > 0 &&
        activeArticle.id !== -1
      ) {
        document.title = `${activeArticle.title} - ${i18n.global.t(
          "routes.NewsDetail"
        )}`;
        document
          .querySelector('meta[name="og:title"]')
          .setAttribute(
            "content",
            `${activeArticle.title} - ${i18n.global.t("routes.NewsDetail")}`
          );
        document
          .querySelector('meta[name="description"]')
          .setAttribute("content", activeArticle.brief);
        document
          .querySelector('meta[name="og:description"]')
          .setAttribute("content", activeArticle.brief);
        document
          .querySelector('meta[name="keywords"]')
          .setAttribute(
            "content",
            activeArticle.tags?.length !== 0
              ? activeArticle.tags + ", " + KEYWORDS
              : KEYWORDS
          );
        document
          .querySelector('meta[name="og:url"]')
          .setAttribute(
            "content",
            i18n.global.locale.value === "uz"
              ? `https://zamon.uz/detail/${activeArticle.url}`
              : `https://zamon.uz/${i18n.global.locale.value}/detail/${activeArticle.url}`
          );
        document
          .querySelector('meta[name="og:image"]')
          .setAttribute("content", activeArticle.image?.original);
        document
          .querySelector('meta[name="article:published_time"]')
          .setAttribute("content", activeArticle.pub_date);
        document
          .querySelector('meta[name="author"]')
          .setAttribute(
            "content",
            `${activeArticle.author?.name} ${activeArticle.author?.surname}`
          );
      }
    };

    watch(
      () => store.getters.activeArticle,
      () => {
        setMetaTags(store.getters.activeArticle);
      }
    );

    watch(
      () => route.params.slug,
      newSlug => {
        if (typeof window !== "undefined") retrieveArticle(newSlug);
      },
      { immediate: true }
    );

    onMounted(() => {
      if (typeof window !== "undefined") {
        if (window.innerWidth > 768) {
          if (window.innerWidth > 1576) {
            window.addEventListener("scroll", handleTextChange);
          }
          isMobile.value = false;
        } else {
          window.addEventListener("scroll", handleMobileScroll);
          isMobile.value = true;
        }
      }
    });

    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", handleTextChange);
        window.removeEventListener("scroll", handleMobileScroll);
      }
    });

    const handleCarousel = dir => {
      if (typeof window !== "undefined") {
        carousel.value.scrollBy({ left: 230 * dir, behavior: "smooth" });

        if (carouselTimeout) clearTimeout(carouselTimeout);
        let carouselTimeout = setTimeout(() => {
          carouselIndicators.left = carousel.value.scrollLeft !== 0;
          carouselIndicators.right = !(
            carousel.value.scrollLeft + carousel.value.offsetWidth - 5 <=
              carousel.value.scrollWidth &&
            carousel.value.scrollLeft + carousel.value.offsetWidth + 5 >=
              carousel.value.scrollWidth
          );
        }, 500);
      }
    };

    return {
      active: computed(() => store.getters.activeArticle),
      collar,
      description,
      carousel,
      anim_scroll,
      handleCarousel,
      carouselIndicators,
      spacer,
      smallTitleIndicator,
      mainTitle,
      show,
      isMobile,
      slug,
      handleSearch,
      query,
      ...useNavigation(),
      ...useFormatter(),
      i18n,
      switchLanguage,
      // retrieveArticle,
      copyToClipBoard,
      thisUrl,
      tags: computed(() =>
        typeof store.getters.activeArticle.tags[0] == "string"
          ? store.getters.activeArticle.tags.split(",")
          : store.getters.activeArticle.tags
      )
    };
  }
  // serverPrefetch() {
  //   return this.retrieveArticle();
  // }
};
</script>

<style lang="scss">
.collar-inner {
  a {
    color: var(--highlight-font-color) !important;
    text-decoration: black;
  }

  img {
    max-width: 100% !important;
    width: 100%;
    height: unset !important;
    background-color: transparent;
  }

  img::after {
    position: relative;
  }

  iframe {
    max-width: 100% !important;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // padding-top: 56.25%; /* 16:9 Aspect Ratio */
    // position: relative;
  }
}
</style>

<style lang="scss" scoped>
html {
  // light
  .inner {
    --bg-page: #fff;
    --text-title: #121212;
    --secondary-bg: 18, 18, 18;
    --btn-color: 18, 18, 18;
    --social-bg: 18, 18, 18;
  }

  &[data-theme="dark"] .inner {
    --bg-page: #121212;
    --text-title: #fff;
    --secondary-bg: 255, 255, 255;
    --btn-color: 255, 255, 255;
    --social-bg: 255, 255, 255;
  }
}
.main-wrapper {
  --viewport-width: 100vw;

  width: 100%;
  overflow: hidden;
  .inner {
    .fa-search {
      cursor: pointer;
    }
    .linear-gradient {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;

      &.top {
        background-image: linear-gradient(var(--bg-page), transparent);
        opacity: 0.3;
      }

      &.bottom {
        background-image: linear-gradient(transparent, var(--bg-page));
      }

      &.spec {
        height: 400px;
        background-image: linear-gradient(
          transparent,
          rgba(var(--primary-bg), 0.7)
        );
      }
    }
    .content {
      // height: 100vh;
      width: 100%;
      position: relative;

      .change-latin {
        position: fixed;
        top: 0;
        right: 0;
        width: 150px;
        height: 106px;
        background: rgba(var(--secondary-bg), 0.15);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
        font-size: 1.6em;
        text-decoration: underline;
        font-weight: 600;
        font-family: Open Sans, serif;
        backdrop-filter: blur(8px);
        color: var(--text-title);
        cursor: pointer;
        text-transform: capitalize;
      }

      .back-button {
        display: none;
      }
    }

    .gallery-holder {
      position: fixed;
      width: 100%;
      height: 100vh;
      top: 0;
      left: 0;

      .main-gallery-holder {
        width: 100%;
        height: 100%;
        position: relative;
      }

      .change-latin-mobile {
        display: none;
      }
    }

    .else-content {
      position: relative;
      height: auto;
      min-height: 100vh;
      margin: 0 150px 0 var(--drawer-width);
      transition: all 0.4s ease;

      .meta-holder {
        position: fixed;
        top: 0;
        left: var(--drawer-width);
        color: var(--text-title);
        z-index: 10;
        .meta-mob-bg {
          display: none;
        }

        .cat-date {
          display: none;
        }

        .search-cont {
          // --search-color: lightgrey;
          --search-color: var(--primary-font-color);

          display: flex;
          align-items: center;
          margin-left: 3.75rem;
          margin-top: 2.75rem;
          width: auto;

          i {
            font-size: 1.4em;
            margin-right: 0.75rem;
          }

          .search-bar {
            background-color: transparent;
            height: 2em;
            width: clamp(45ch, 50%, 75ch);
            color: var(--search-color);
            border-radius: 4px;
            transition: all 0.4s ease;
            padding-left: 0.5rem;

            &:focus,
            &:focus-visible,
            &:active {
              background-color: rgba(var(--primary-bg), 0.4);
              border: none;
              outline: none;

              // --search-color: #fff;
            }

            &::placeholder {
              color: var(--search-color);
              transition: all 0.4s ease;
            }

            &::content {
              color: var(--search-color);
            }
          }
        }

        .title {
          max-width: 53.5rem;
          font-size: 3.5em;
          margin-top: 3.5rem;
          margin-left: 1.875rem;
          font-family: Roboto;
          transition: all 0.4s ease;
          position: relative;
          z-index: 11;
          pointer-events: none;

          &.small {
            font-size: 2.5rem;
            max-width: calc(
              var(--viewport-width) - 1050px - var(--drawer-width)
            );
          }
        }
      }

      .collar-holder {
        display: flex;
        align-items: flex-end;
        flex-direction: column;

        .spacer {
          width: 100%;
          height: 44rem;
        }

        .collar {
          width: 100%;
          max-width: 830px;
          position: relative;
          z-index: 20;
          background-color: var(--foreground-color);
          box-shadow: -10px 1px 27px rgba(var(--bg-page), 0.25);
          border-radius: 4px 0px 0px 4px;
          margin-bottom: 5.625rem;

          .change-latin-tablet {
            display: none;
          }

          .video-content {
            position: relative;
            width: 100%;
            padding-top: 45%; /* 22:13 Aspect Ratio */
            display: block;
            margin-bottom: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;

            .video-player {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;

              .video {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
              }

              .play-btn {
                width: 50px;
                height: 42px;
                color: #fff;
                font-size: 1.625em;
                padding: 0.22em 1.2em;
                position: relative;
                border: 1px solid #fff;
                transition: all 0.4s ease, border 0s;
                i {
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-left: auto;
                }
                &:hover {
                  color: #121212;
                  background-color: #fff;
                  border: none;
                }
              }
            }
          }

          .collar-inner {
            margin-top: 3.875rem;
            margin-bottom: 2.25rem;
            margin-left: 2.875rem;
            margin-right: 2.875rem;
            font-family: Open Sans;
            font-size: 1.1em;
            color: var(--secondary-font-color);
            line-height: 1.625em;
            text-align: justify;

            // .headliner {
            //   font-size: 5.625rem;
            //   line-height: 7.5rem;
            //   height: 5.625rem;
            //   font-size: 4em;
            //   line-height: 2em;
            //   position: relative;
            //   float: left;
            //   display: block;
            // }

            .content {
              font-size: 1em;
              line-height: 2em;
              display: block;
            }
          }

          .recs-holder {
            width: 100%;
            border-top: 1px solid var(--background-color);
            padding-top: 1.625rem;
            padding-bottom: 3.75rem;
            color: var(--secondary-font-color);

            .controls-wrap {
              display: flex;
              justify-content: space-between;
              margin-left: 2.875rem;

              .headliner {
                font-family: Open Sans;
                font-size: 1.5rem;
              }

              .controls-holder {
                display: flex;

                button,
                a {
                  height: 44px;
                  width: 236px;
                  margin: 0 0.5rem;
                  border-radius: 4px;
                  cursor: pointer;
                  background-color: rgba(var(--primary-bg), 0.2);
                  font-size: 2em;
                  transition: all 0.4s ease;

                  &:hover {
                    background-color: rgba(var(--primary-bg), 0.6);
                  }
                }

                .disabled {
                  cursor: not-allowed;
                  opacity: 0.5;
                }
              }
            }

            .carousel-holder {
              position: relative;

              .carousel {
                width: 100%;
                display: flex;
                overflow-x: auto;
                margin-top: 1.875rem;
                position: relative;
                scroll-snap-type: x mandatory;
                -ms-overflow-style: none; /* IE and Edge */
                scrollbar-width: none; /* Firefox */

                &::-webkit-scrollbar {
                  display: none;
                }

                .news-item {
                  height: auto;
                  position: relative;
                  padding-left: 1.875rem;
                  scroll-snap-align: start;

                  &:first-child {
                    padding-left: 2.875rem;

                    .cat-wrapper {
                      left: 2.875rem;
                    }
                  }

                  &:last-child {
                    padding-right: 2.875rem;
                  }

                  .img-holder {
                    width: 250px;
                    border-radius: 4px;
                    padding-top: 59.09%; /* 22:13 Aspect Ratio */
                    position: relative;
                    overflow: hidden;

                    .img {
                      width: 100%;
                      height: 100%;
                      position: absolute;
                      left: 0;
                      top: 0;
                      border-radius: 4px;
                      transition: all 0.4s ease;
                    }
                  }

                  .cat-wrapper {
                    position: absolute;
                    left: 1.875rem;
                    top: 0;
                    display: flex;
                    align-items: center;
                    background-color: var(--foreground-color);
                    height: 1.6rem;
                    font-family: Open Sans;
                    z-index: 999;

                    .cat-meta {
                      display: flex;
                      align-items: center;
                      justify-content: center;

                      &:first-child {
                        font-size: 0.8em;
                        font-weight: 600;
                        text-transform: uppercase;
                        padding: 0 0.375rem;
                      }
                    }
                  }

                  .title {
                    font-family: Roboto;
                    font-size: 1.25em;
                    font-weight: 500;
                    line-height: 1.5rem;
                    padding-top: 0.625rem;
                  }

                  .date-wrapper {
                    font-weight: 300;
                    font-size: 0.875em;
                    padding-top: 0.75em;
                    opacity: 0.8;
                    font-family: Open Sans;
                  }
                }
              }

              .carousel-gradient {
                background-image: linear-gradient(
                  to right,
                  transparent 20%,
                  var(--foreground-color)
                );
                position: absolute;
                right: 0;
                top: 0;
                height: 100%;
                width: 70px;
              }
            }
          }
        }
      }
    }
  }
}
.brief-first-leter {
  display: inline-block;
  font-size: 1em;
  line-height: 2em;
  &::first-letter {
    text-transform: uppercase;
    font-family: Alice;
    font-size: 5em;
    @media screen and (max-width: 768px) {
      font-size: 2.5em;
    }
    // line-height: 1em;
    // margin-right: 0.875rem;
    // position: relative;
    // float: left;
    // display: block;
  }
}

.animation_scroll {
  /*анимация при скролле */
  width: 100%;
  height: 140vh;
  background: var(--foreground-color);
  position: absolute;
  z-index: 10;
  // top: 380px;
  top: 100%;
  display: none;
  transition: all 0.1s ease;
}

@media screen and (max-width: 1576px) {
  .main-wrapper {
    --viewport-width: calc(100vw / 0.7);

    .inner {
      .content {
        .else-content {
          .meta-holder {
            position: absolute;
            left: 0;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .main-wrapper {
    .inner {
      // zoom: 0.7;

      .content {
        .change-latin {
          visibility: hidden;
        }

        .gallery-holder {
          height: calc(100vh / 0.7);
        }

        .else-content {
          margin: 0 1em 0 0;
          min-height: calc(100vh / 0.7);

          .meta-holder {
            position: absolute;
            left: var(--drawer-width);
          }

          .collar-holder {
            .collar {
              // max-width: 930px;
              width: 74%;

              .change-latin-tablet {
                position: absolute;
                top: 1rem;
                right: 0;
                width: 60px;
                height: 50px;
                margin-right: 2.875rem;
                background: rgba(var(--primary-bg), 0.8);
                display: flex;
                justify-content: center;
                align-items: center;
                text-decoration: underline;
                font-weight: 600;
                font-family: Open Sans, serif;
                backdrop-filter: blur(8px);
                color: var(--primary-font-color);
                cursor: pointer;
                text-transform: capitalize;
                border-radius: 5px;
                mix-blend-mode: difference;
                z-index: 20;
              }

              // .collar-inner {
              // &::first-letter {
              //   font-size: 8em;
              //   margin-right: 0.875rem;
              //   line-height: 0.7em;
              // }
              // }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .main-wrapper {
    .inner {
      .content {
        .else-content {
          .meta-holder {
            position: absolute;
            left: var(--drawer-width);
          }
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .kground {
    animation-duration: 1.75s !important;
  }
  .main-wrapper {
    .inner {
      zoom: 1;

      .content {
        .gallery-holder {
          height: 100vh;
        }

        .else-content {
          margin: 0;
          min-height: 100vh;

          .meta-holder {
            position: relative;
            padding-bottom: 8rem;
            display: flex;
            flex-direction: column;
            left: 0;
            margin-left: calc(var(--drawer-width) + 1.875rem);

            .title {
              font-size: 2.5em;
              margin-top: 1.8rem;
              margin-left: 0;
            }
          }

          .collar-holder {
            .spacer {
              display: none;
            }

            .collar {
              width: 100%;
              border-radius: 0;
              // max-width: calc(100% - var(--drawer-width));

              .recs-holder {
                .controls-holder {
                  button,
                  a {
                    width: 100px;
                    margin: 0 0.7rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .animation_scroll {
    display: unset;
  }

  .main-wrapper {
    .inner {
      .content {
        .back-button {
          // position: -webkit-sticky;
          // position: sticky;
          // top: var(--header-main-height);
          position: absolute;
          height: 60px;
          z-index: 20;
          bottom: 0;
          padding-left: 1.875rem;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          mix-blend-mode: difference;
          color: #fff;

          .back-icon {
            position: relative;
            width: 1.5em;
            height: 1.5em;
            background: #3d3d3d;
            border-radius: 10px;
            font-size: 2.6em;
            font-weight: 300;
            display: flex;
            align-items: center;
            margin-right: 0.2em;
            justify-content: center;
            mix-blend-mode: difference;
          }

          .back-text {
            position: relative;
            display: inline-block;
            font-size: 1.5em;
            font-family: Open Sans;
            font-style: normal;
            font-weight: 300;
            opacity: 0.7;
            text-transform: capitalize;
            mix-blend-mode: difference;
          }

          .back-btn-bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            // background-color: var(--background-color);
          }

          // &.back-button-alternative {
          //   .back-btn-bg {
          //     background-color: var(--foreground-color);
          //   }
          // }
        }

        .gallery-holder {
          display: flex;
          position: relative;
          top: 0;
          width: 100%;
          height: 400px;

          .main-gallery-holder {
            position: fixed;
            top: 0;
            left: 0;
            width: inherit;
            height: inherit;
          }

          .change-latin-mobile {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 60px;
            height: 60px;
            margin-right: 1.875rem;
            background: rgba(var(--btn-color), 0.15);
            display: flex;
            justify-content: center;
            align-items: center;
            text-decoration: underline;
            font-weight: 600;
            font-family: Open Sans, serif;
            backdrop-filter: blur(8px);
            color: var(--text-title);
            cursor: pointer;
            text-transform: capitalize;
            border-radius: 5px;
            // mix-blend-mode: difference;
            z-index: 20;
          }
        }
        .else-content {
          width: 100%;
          margin: 0;
          background-color: var(--background-color);

          .search-cont {
            display: none;
          }

          .meta-holder {
            position: relative;
            left: 0;
            top: 0;
            // text-align: left;
            margin-left: 0;
            padding-bottom: 2rem;
            mix-blend-mode: difference;

            .meta-mob-bg {
              display: block;
              position: absolute;
              width: 100%;
              height: 100%;
              // background-color: var(--bg-page);
              // background-color: #000;

              // mix-blend-mode: difference;
            }

            .cat-date {
              position: absolute;
              display: flex;
              width: auto;
              margin-left: 1.875rem;
              opacity: 0.8;
              // height: 50%;
              font-family: Open Sans;
              margin-bottom: 1.875rem;
              margin-top: 1.2rem;
              font-size: 1.3em;
              font-weight: 600;
              mix-blend-mode: difference;
              z-index: 11;
              color: #fff;

              .slash {
                margin-left: 0.8rem;
              }

              .date {
                font-size: 1em;
                margin-left: 0.8rem;
                text-transform: lowercase;
              }
            }
            .title {
              max-width: 100%;
              font-size: 2.5em;
              margin-top: 4.5rem;
              margin-left: 1.875rem;
              margin-right: 1.875rem;
              mix-blend-mode: difference;
              color: #fff;

              // &::first-letter {
              //   text-transform: uppercase;
              //   font-family: Roboto;

              //   font-size: 2.3em;
              //   line-height: 1em;
              //   margin-right: 0.875rem;
              //   position: relative;
              //   float: left;
              //   display: block;
              // }
            }
            .small {
              font-size: 2.5rem;
              max-width: 100% !important;
            }
            .search-cont {
              display: none;
            }
          }

          .collar-holder {
            display: flex;
            position: relative;
            align-items: center;
            justify-content: center;
            width: 100%;

            .spacer {
              height: 5rem;
            }

            .collar {
              max-width: 100%;
              box-shadow: none;

              .change-latin-tablet {
                display: none;
              }

              .video-content {
                display: block;
                display: flex;
                justify-content: center;
                align-items: center;

                .video {
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
                .play-btn {
                  width: 50px;
                  height: 42px;
                  color: #fff;
                  font-size: 1.625em;
                  padding: 0.22em 1.2em;
                  position: relative;
                  border: 1px solid #fff;
                  transition: all 0.4s ease, border 0s;
                  i {
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-left: auto;
                  }
                  &:hover {
                    color: #121212;
                    background-color: #fff;
                    border: none;
                  }
                }
              }

              .collar-inner {
                margin-top: 1.8rem;
                margin-left: 1.1rem;
                margin-right: 1rem;
                font-size: 1.25em;

                &::first-letter {
                  // text-transform: uppercase;
                  // font-family: Roboto;

                  // font-size: 4em;
                  // line-height: 1em;
                  // position: relative;
                  // float: left;
                  // display: block;
                }
              }

              .recs-holder {
                position: relative;
                // height: 350px;
                margin: 0 0 30px 0;
                padding-bottom: 4rem;

                .controls-wrap {
                  margin-left: 1.875rem;

                  .headliner {
                    font-size: 1.8rem;
                  }

                  .controls-holder {
                    width: 90%;
                    left: 5%;
                    position: absolute;
                    bottom: -15px;
                    justify-content: center;

                    button,
                    a {
                      width: 100%;
                      height: 2em;
                      margin: 0;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    }

                    .right {
                      display: none;
                    }
                  }
                }

                .carousel-holder {
                  .carousel {
                    .news-item {
                      &:first-child {
                        padding-left: 1.875rem;

                        .cat-wrapper {
                          left: 1.875rem;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 430px) {
  .main-wrapper {
    .inner {
      .content {
        .else-content {
          .meta-holder {
            .title {
              font-size: 1.8em;
            }
          }
          .collar-holder {
            font-size: 0.8em;
            .collar {
              .recs-holder {
                .controls-wrap {
                  margin-left: 1.875rem;

                  .headliner {
                    font-size: 1.8em;
                  }

                  .controls-holder {
                    button,
                    a {
                      margin: 0;
                      width: 100%;
                    }
                  }
                }

                .carousel-holder {
                  .carousel {
                    .news-item {
                      &:first-child {
                        padding-left: 1.875rem;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .cat-date {
    font-size: 1em !important;
  }
}

.info {
  display: flex;
  font-size: 0.4em;
  margin-bottom: 1em;
  .category {
    margin-right: 1em;
  }
  .slash {
    display: none;
  }
  .data-news {
    margin-right: 1em;
  }

  @media screen and (max-width: 992px) {
    display: none;
  }
}

.views-mobile {
  @media screen and (max-width: 992px) {
    margin-left: 2em;
  }
}

.tag-block {
  color: rgba(var(--primary-bg), 0.8);
  margin-left: 2.875rem;
  margin-right: 2.875rem;
  display: flex;
  justify-content: space-between;
  font-size: 1.125em;
  font-weight: 500;
  margin-bottom: 2.5rem;
}
.tag {
  flex: 1 0 70%;
  &__title {
    color: rgba(var(--primary-bg), 0.8);
    margin-bottom: 1em;
    text-transform: capitalize;
  }
  &__link {
    padding: 0.4rem 0.8rem;
    background: rgba(var(--primary-bg), 0.1);
    color: rgba(var(--primary-bg), 0.6);
    border-radius: 4px;
    text-transform: uppercase;
    margin: 0 0.8rem 0.8rem 0;
    display: inline-block;
    // pointer-events: none;
    cursor: default;
    &:hover {
      background: rgba(var(--primary-bg), 0.5);
      color: rgba(var(--secondary-bg), 1);
    }
  }
}

.social-links {
  max-width: 100%;

  &__title {
    text-transform: capitalize;
    margin-bottom: 1em;
  }
  .social {
    font-size: 1.5em;
    button {
      background: transparent;
      color: inherit;
    }
    .link {
      cursor: pointer;
      display: inline-block;
      position: relative;
      transition: all 0.4s ease;
      span {
        display: block;
        padding: 0.3rem 0.6rem;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
        left: 50%;
        z-index: 100;
        white-space: nowrap;
        pointer-events: none;
        opacity: 0;
        font-size: 0.5em;
        color: rgba(var(--social-bg), 0.8);
        background-color: rgba(var(--primary-bg), 0.9);
        border-radius: 0.3rem;
        text-transform: uppercase;

        transition: top 0.2s ease-out, opacity 0.2s cubic-bezier(0, 0, 0, 1);
      }
      &:hover {
        span {
          z-index: 100;
          top: 170%;
          visibility: visible;
          opacity: 1;
        }
      }
    }
    .link:nth-child(n) {
      margin-right: 1.5rem;
    }
  }
}

@media screen and (max-width: 992px) {
  .tag-block {
    font-size: 1.5em;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .tag {
    order: 1;
    text-align: center;
    &__link {
      font-size: 0.8em;
    }
  }
  .social-links {
    width: 100%;
    margin-bottom: 3rem;
    text-align: center;
    .social {
      font-size: 2.8rem;
      display: flex;
      justify-content: space-around;
      width: 70%;
      margin: 0 auto;
      .link {
        margin: 0px !important;

        // display: flex;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .tag-block {
    font-size: 1.9em;
  }

  .social-links {
    .social {
      width: 100%;
      font-size: 2.2rem;
    }
  }
}
</style>
